import { render } from "./perMoadl.vue?vue&type=template&id=beb8d512&scoped=true"
import script from "./perMoadl.vue?vue&type=script&lang=js"
export * from "./perMoadl.vue?vue&type=script&lang=js"

import "./perMoadl.vue?vue&type=style&index=0&id=beb8d512&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beb8d512"]])

export default __exports__